export const timePerJobViewTypes = ['job', 'transaction', 'assignee'] as const;
